export { default as PromotionsTable } from './PromotionsTable';
export { default as PromotionsProductSearch } from './PromotionsProductSearch';
export { default as PromotionSetup } from './PromotionSetup';
export { default as BuyAGetBProductSearches } from './BuyAGetBProductSearches';
export { default as ByQuantityFields } from './ByQuantityFields';
export { default as ByTotalPriceProductFields } from './ByTotalPriceProductFields';
export { default as ByTotalPriceDiscountFields } from './ByTotalPriceDiscountFields';
export { default as BuyAGetBFields } from './BuyAGetBFields';
export { default as EditPromotionModal } from './EditPromotionModal';



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/index.js